export enum VerificationStatus {
  NONE = 'none',
  IN_PROGRESS = 'inprogress',
  VERIFIED = 'verified',
  VALIDATION_ERROR = 'validation_error',
  MANUAL_OVERRIDE = 'manual_override'
}
